import { useDmMessagePatient } from '../../../../hooks/useDmMessagesInbox';
import { PATIENT_LOOKUP_FILTERS } from '../../../monitoring/messages/useDmMessagePanelPatient';
import { toAiReplySource } from '../../../monitoring/messages/triage/aiTriageState';
import type { EmbeddableActionRunnerProps } from '../types';
import { DmPatientMessagesPanel } from './DmPatientMessagesPanel';

type DmPatientMessagesTabProps = Pick<
    EmbeddableActionRunnerProps,
    'patientId' | 'onBack' | 'embedded'
>;

// Fetches the patient's unreviewed count and AI reply itself, for hosts with no DM-patient-detail
// query of their own to hand down (the work-queue sidebar, notifications tab, Messages action).
export function DmPatientMessagesTab({ patientId, onBack, embedded }: DmPatientMessagesTabProps) {
    const { data } = useDmMessagePatient(patientId, PATIENT_LOOKUP_FILTERS);
    const patient = data?.patient ?? null;
    return (
        <DmPatientMessagesPanel
            patientId={patientId}
            unreviewedCount={patient?.unreviewedCount ?? null}
            lastResolution={patient?.lastResolution ?? null}
            aiReply={patient ? toAiReplySource(patient) : undefined}
            onBack={onBack}
            embedded={embedded}
        />
    );
}
